import React from "react";
import makeClasses from "./styles";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import Tooltip from "../Tooltip";
import { useSelector } from "react-redux";
import { Language } from "../../utils";

const BorderedCheckbox = ({ checked = false, onChange }) => {
  const classes = makeClasses();
  const { languageTexts } = useSelector((state) => ({
    languageTexts: state.language.texts || {},
  }));
  const i18n = Language(languageTexts);

  return (
    <div className={classes.borderedCheckboxContainer}>
      <FormControlLabel
        control={
          <Checkbox
            className={classes.checkbox}
            checked={checked}
            onChange={onChange}
          />
        }
        label={
          <div>
            <div className={classes.checkboxLabel}>
              {i18n.get("Components.BorderedCheckbox.Label")}
            </div>
            <div className={classes.checkboxSubtitle}>
              {i18n.get("Components.BorderedCheckbox.LabelDesc")}
            </div>
          </div>
        }
      />

      <Tooltip title={i18n.get("Components.BorderedCheckbox.Tooltip")}>
        <InfoOutlinedIcon />
      </Tooltip>
    </div>
  );
};

export default BorderedCheckbox;
